import { Operation } from '../../../__generated__/globalTypes'

import {
  MarketingParagraphFragment,
  marketingParagraphFragmentString,
} from '../../fragments/__generated__/MarketingParagraphFragment'

import getMarketingContentRawString from '../GetMarketingContent.graphql'

const getMarketingContentString = [
  getMarketingContentRawString,
  marketingParagraphFragmentString,
].join('\n\n')

export type GetMarketingContentData = {
  complianceMessage: MarketingParagraphFragment
  whyMyPhoneNumberMessage: MarketingParagraphFragment
  unverifiedAccountsFoundCopy: MarketingParagraphFragment
  phoneNotFoundCopy: MarketingParagraphFragment
  customerReferralOptInMessage: MarketingParagraphFragment
  greenerStillAffiliateOptInMessage: MarketingParagraphFragment
  sharingInformationCopy: MarketingParagraphFragment
  loginWelcomeMessage: MarketingParagraphFragment
  affiliateLoginMessage: MarketingParagraphFragment
  immediateSendEditingMessage: MarketingParagraphFragment
  futureSendEditingMessage: MarketingParagraphFragment
  bulkPromoJoinMessage: MarketingParagraphFragment
  subscriptionPurchaseSuccess: MarketingParagraphFragment
  cardPackagePurchaseSuccess: MarketingParagraphFragment
}

export type GetMarketingContent = Operation<GetMarketingContentData>

export const GetMarketingContent = (): GetMarketingContent => ({
  query: getMarketingContentString,
  variables: undefined,
})
